module.exports = __webpack_public_path__ + "img/cameras.cf438aa0.png";